import React, { Fragment, useState, useEffect } from 'react';
import * as Yup from 'yup';
import numeral from 'numeral';
import NumberFormat from 'react-number-format';

import PerfectScrollbar from 'react-perfect-scrollbar';

import agm from '../../services/agm';
import Alerts from '../../utils/alerts';
import Find from '../requests/Find';

import { makeStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';

import {
    KeyboardDatePicker
} from '@material-ui/pickers';

import {
    Tooltip,
    Avatar,
    Button,
    Box,
    colors,
    Icon,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableContainer,
    Typography,
    Grid,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    TextField,
    Card,
    CardContent,
    IconButton,
    FormControl,
    InputLabel,
    MenuItem,
    Select
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: 680,
        backgroundColor: theme.palette.background.paper,
    },
    avatar: {
        marginRight: theme.spacing(1),
        backgroundColor: colors.grey[200]
    },
    container: {
        maxHeight: 340,
    },
    input: {
        color: colors.cyan['A700']
    },
    inputErro: {
        color: colors.red[900]
    },
    products: {
        padding: 0
    }
}));

import { IoMdCart } from "react-icons/io";
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import Add from '@material-ui/icons/AddCircleOutline';

const Request = ({ item, open, selectedMode, closeRequest, requestValues, dependencies }) => {

    const classes = useStyles();

    const [openAlert, setOpenAlert] = useState(false);
    const [message, setMessage] = useState({});
    const [openFind, setOpenFind] = useState(false);

    const closeAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const closeFind = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenFind(false);
    };

    const getRandomId = () => {
        var min = Math.ceil(9900);
        var max = Math.floor(10000);
        return parseInt(Math.floor(Math.random() * (max - min + 1)) + min) * -1;
    };

    const selectProduct = (values, produto) => {
        values.idProduto = produto.id;
        values.qtdProduto = 1;
        values.codigoProduto = produto.codigo;
        values.nomeProduto = produto.nome;
        values.custoProduto = numeral((produto.custo) ? produto.custo : 0).format('0.00');
        values.valorMaterial = numeral((produto.valor) ? produto.valor : 0).format('0.00');
        values.valorInstalacao = numeral((produto.instalacao) ? produto.instalacao : 0).format('0.00');
        values.produto = produto;
        closeFind();
    }

    const handleAddItem = async (values) => {
        if (values.idProduto) {
            dependencies.items.push({
                id: getRandomId(),
                qtd: values.qtdProduto,
                custo: values.custoProduto,
                valor: values.valorMaterial,
                instalacao: values.valorInstalacao,
                produto: values.produto,
                data: values.data,
                estoque: values.estoque,
                aberto: 1
            });
            values.idProduto = ''
            values.qtdProduto = '';
            values.codigoProduto = '';
            values.nomeProduto = '';
            values.custoProduto = '';
            values.valorMaterial = '';
            values.valorInstalacao = '';
            values.produto = {};
            document.getElementById('codigoProduto').focus();
        } else {
            setOpenFind(true);
        }
    }

    const handleRemoveItem = async (item, values) => {
        for (let index = 0; index < dependencies.items.length; index++) {
            var prod = dependencies.items[index];
            if (prod.id == item.id) {
                dependencies.items.splice(index, 1);
                dependencies.removes.push(prod);
                break;
            }
        }
        values.valorMaoObra = 0.0;
        values.valorMaterial = 0.0;
        for (let index = 0; index < dependencies.items.length; index++) {
            prod = dependencies.items[index];
            values.valorMaoObra = (parseFloat(values.valorMaoObra) + (parseFloat(parseFloat(prod.instalacao) * parseFloat(prod.qtd))));
            values.valorMaterial = (parseFloat(values.valorMaterial) + (parseFloat(parseFloat(prod.valor) * parseFloat(prod.qtd))));
        }
        values.total = (parseFloat(values.valorMaoObra) + parseFloat(values.valorMaterial) - parseFloat(values.valorDesconto));
        document.getElementById('codigoProduto').focus();
        document.getElementById('nomeProduto').focus();
        await document.getElementById('codigoProduto').focus();
    }

    useEffect(() => {
        return
    }, []);

    return (
        <Fragment>

            <Alerts message={message}
                open={openAlert}
                closeAlert={closeAlert} />

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="xl" fullWidth>
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Lançar Retirada
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                ordem: Yup.string().required('Ocorrência é obrigatória'),
                                data: Yup.string().required('Ocorrência é obrigatória'),
                                estoque: Yup.string().required('Estqoue é obrigatório'),
                            })
                        }
                        onSubmit={(values, formik) => {
                            requestValues(values, dependencies.items);
                            formik.setSubmitting(false);
                        }}

                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (

                            <form onSubmit={handleSubmit}>

                                <Find open={openFind}
                                    closeFind={closeFind}
                                    selectProduct={selectProduct}
                                    values={values}
                                    selectMode={selectedMode} />

                                <Box className={classes.root} >

                                    <Grid
                                        container
                                        spacing={1}
                                        xs="auto"
                                    >
                                        <Grid
                                            item
                                            md={1}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.ordem && errors.ordem)}
                                                fullWidth
                                                required
                                                label="Lançamento"
                                                margin="normal"
                                                name="ordem"
                                                id="ordem"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={numeral(values.ordem).format('000000')}
                                                variant="outlined"
                                                inputProps={
                                                    { readOnly: true, }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md="auto"
                                            xs={12}>

                                            <KeyboardDatePicker
                                                error={Boolean(touched.data && errors.data)}
                                                fullWidth
                                                required
                                                cancelLabel="Cancelar"
                                                margin="normal"
                                                inputVariant="outlined"
                                                id="data"
                                                name="data"
                                                label="Data do Lançamento"
                                                format="DD/MM/YYYY"
                                                value={values.data}
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("data", value)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid item
                                            md={2}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth margin='normal'>
                                                <InputLabel shrink htmlFor="estoque" required>Estoque de Destino</InputLabel>
                                                <Select notched
                                                    error={Boolean(touched.estoque && errors.estoque)}
                                                    required
                                                    fullWidth={true}
                                                    label="Estoque de Destino"
                                                    variant="outlined"
                                                    id="estoque"
                                                    name="estoque"
                                                    value={values.estoque}
                                                    onChange={handleChange}
                                                    inputProps={{
                                                        name: 'estoque',
                                                        id: 'estoque',
                                                    }}
                                                >

                                                    {dependencies.stocks.map((stock) => (
                                                        <MenuItem key={stock.id} value={stock.id}>{stock.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={3}
                                            xs={12}
                                        >
                                            <FormControl variant="outlined" fullWidth margin='normal'>
                                                <InputLabel shrink htmlFor="tecnico" required>Técnico Responsável</InputLabel>
                                                <Select notched
                                                    error={Boolean(touched.tecnico && errors.tecnico)}
                                                    required
                                                    fullWidth={true}
                                                    label="Técnico Responsável"
                                                    variant="outlined"
                                                    id="tecnico"
                                                    name="tecnico"
                                                    value={values.tecnico}
                                                    onChange={handleChange}
                                                    inputProps={{
                                                        name: 'tecnico',
                                                        id: 'tecnico',
                                                    }}
                                                >

                                                    {dependencies.technicians.map((tech) => (
                                                        <MenuItem key={tech.id} value={tech.id}>{tech.nome} [ {tech.prestadora.nome} ]</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>
                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}
                                        >
                                            <TextField
                                                error={Boolean(touched.anotacao && errors.anotacao)}
                                                fullWidth
                                                label="Anotação (Campo Livre)"
                                                length={256}
                                                multiline
                                                margin="normal"
                                                id="anotacao"
                                                name="anotacao"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.fornecedor}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            md={12}
                                            xs={12}>

                                            <Card className={classes.products}>
                                                <CardContent>

                                                    <Grid container
                                                        direction="row"
                                                        justifyContent="flex-start"
                                                        alignItems="center"
                                                        spacing={1}  >

                                                        <Grid
                                                            item
                                                            md={1}
                                                            xs={12}>

                                                            <TextField
                                                                fullWidth
                                                                label="Código"
                                                                margin="normal"
                                                                name="codigoProduto"
                                                                id="codigoProduto"
                                                                onBlur={e => {
                                                                    handleBlur(e);
                                                                }}
                                                                onChange={handleChange}
                                                                value={values.codigoProduto}
                                                                variant="outlined"
                                                                InputLabelProps={{ shrink: true }}
                                                            />

                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md={4}
                                                            xs={12}>

                                                            <TextField
                                                                fullWidth
                                                                label="Nome"
                                                                margin="normal"
                                                                name="nomeProduto"
                                                                id="nomeProduto"
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                                value={values.nomeProduto}
                                                                variant="outlined"
                                                                InputLabelProps={{ shrink: true }}
                                                            />
                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md={1}
                                                            xs={12}>
                                                            <NumberFormat
                                                                fullWidth
                                                                label="Quantidade"
                                                                margin="normal"
                                                                name="qtdProduto"
                                                                id="qtdProduto"
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                                value={values.qtdProduto}
                                                                variant="outlined"
                                                                decimalScale="2"
                                                                fixedDecimalScale="true"
                                                                customInput={TextField}
                                                                InputLabelProps={{ shrink: true }}
                                                            />

                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md={1}
                                                            xs={12}>
                                                            <NumberFormat
                                                                fullWidth
                                                                label="Valor Custo"
                                                                margin="normal"
                                                                name="custoProduto"
                                                                id="custoProduto"
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                                value={values.custoProduto}
                                                                variant="outlined"
                                                                decimalScale="2"
                                                                fixedDecimalScale="true"
                                                                customInput={TextField}
                                                                InputLabelProps={{ shrink: true }}
                                                            />

                                                        </Grid>


                                                        <Grid
                                                            item
                                                            md={1}
                                                            xs={12}>
                                                            <NumberFormat
                                                                fullWidth
                                                                label="Valor Material"
                                                                margin="normal"
                                                                name="valorMaterial"
                                                                id="valorMaterial"
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                                value={values.valorMaterial}
                                                                variant="outlined"
                                                                decimalScale="2"
                                                                fixedDecimalScale="true"
                                                                customInput={TextField}
                                                                InputLabelProps={{ shrink: true }}
                                                            />

                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md={1}
                                                            xs={12}>
                                                            <NumberFormat
                                                                fullWidth
                                                                label="Valor Instalação"
                                                                margin="normal"
                                                                name="valorInstalacao"
                                                                id="valorInstalacao"
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                                value={values.valorInstalacao}
                                                                variant="outlined"
                                                                decimalScale="2"
                                                                fixedDecimalScale="true"
                                                                customInput={TextField}
                                                                InputLabelProps={{ shrink: true }}
                                                            />

                                                        </Grid>

                                                        <Grid item
                                                            md={1}
                                                            xs={12}>

                                                            <Button
                                                                color="secondary"
                                                                size="medium"
                                                                variant="contained"
                                                                startIcon={<Add />}
                                                                onBlur={handleBlur}
                                                                onClick={() => { handleAddItem(values) }}>
                                                                Adicionar
                                                            </Button>
                                                        </Grid>
                                                    </Grid>

                                                    <br></br>
                                                    <Grid container
                                                        direction="row"
                                                        justify="flex-start"
                                                        alignItems="center"
                                                        spacing={1}  >

                                                        <Grid item
                                                            md={12}
                                                            xs={12}>

                                                            <TableContainer component={PerfectScrollbar} className={classes.container}>

                                                                <Table stickyHeader size="small" aria-label="a dense table" >
                                                                    <TableHead>

                                                                        <TableRow>

                                                                            <TableCell>
                                                                                Código
                                                                            </TableCell>

                                                                            <TableCell>
                                                                                Nome
                                                                            </TableCell>

                                                                            <TableCell align="right">
                                                                                Valor Custo
                                                                            </TableCell>

                                                                            <TableCell align="right">
                                                                                Valor Material
                                                                            </TableCell>

                                                                            <TableCell align="right">
                                                                                Valor Instalação
                                                                            </TableCell>

                                                                            <TableCell>
                                                                                Quantidade
                                                                            </TableCell>

                                                                            <TableCell>
                                                                                Unidade
                                                                            </TableCell>

                                                                            <TableCell>
                                                                                &nbsp;
                                                                            </TableCell>

                                                                        </TableRow>

                                                                    </TableHead>

                                                                    <TableBody>
                                                                        {dependencies.items.map((prod) => (
                                                                            <TableRow
                                                                                hover
                                                                                key={prod.id}
                                                                            >
                                                                                <TableCell width={10}>
                                                                                    <Box
                                                                                        alignItems="center"
                                                                                        display="flex"
                                                                                    >
                                                                                        <Avatar
                                                                                            className={classes.avatar}
                                                                                        >
                                                                                            {<Icon component={IoMdCart} style={{ color: colors.cyan[500] }} ></Icon>}
                                                                                        </Avatar>
                                                                                        {numeral(prod.produto.codigo).format('0000')}
                                                                                    </Box>
                                                                                </TableCell>

                                                                                <TableCell>
                                                                                    {prod.produto.nome}
                                                                                </TableCell>

                                                                                <TableCell align="right">
                                                                                    {numeral(prod.custo).format('0.00')}
                                                                                </TableCell>

                                                                                <TableCell align="right">
                                                                                    {numeral(prod.valor).format('0.00')}
                                                                                </TableCell>

                                                                                <TableCell align="right">
                                                                                    {numeral(prod.instalacao).format('0.00')}
                                                                                </TableCell>


                                                                                <TableCell align="center">
                                                                                    {prod.qtd}
                                                                                </TableCell>

                                                                                <TableCell align="center">
                                                                                    {(prod.produto.unidadeProduto) ? prod.produto.unidadeProduto.nome : "??"}
                                                                                </TableCell>


                                                                                <TableCell >
                                                                                    <Tooltip title="Excluir Produto">
                                                                                        <IconButton
                                                                                            disabled={!prod.aberto}
                                                                                            color="secondary"
                                                                                            className={classes.btntreatment}
                                                                                            children={<DeleteRoundedIcon />}
                                                                                            size="medium"
                                                                                            onClick={() => { handleRemoveItem(prod, values) }}>
                                                                                        </IconButton>
                                                                                    </Tooltip>
                                                                                </TableCell>

                                                                            </TableRow>
                                                                        ))
                                                                        }

                                                                        {(dependencies.items.length == 0) ? (
                                                                            <TableRow  >
                                                                                <TableCell colSpan={10} align="center" >
                                                                                    Nenhum Produto Foi Adicionado.
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        ) : ('')}


                                                                    </TableBody>
                                                                </Table>
                                                            </TableContainer>

                                                        </Grid>

                                                    </Grid>

                                                </CardContent>
                                            </Card>
                                        </Grid>

                                    </Grid>

                                </Box>

                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>

                                    <Grid container
                                        direction="row"
                                        justifyContent="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Lançar no Estoque
                                            </Button>
                                        </Grid>

                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeRequest() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Request;